export default "__VITE_ASSET__BqOieFy0__"